import React, { useEffect, useState } from "react";
import api from "../api/axios";
import Swal from "sweetalert2";

const AddGrievance = () => {
  const [captcha1] = useState(Math.floor(Math.random() * 10) + 1);
  const [captcha2] = useState(Math.floor(Math.random() * 10) + 1);
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [grievanceTypes, setGrievanceTypes] = useState([]);
  const [grievanceSubTypes, setGrievanceSubTypes] = useState([]);
  const [zones, setZones] = useState([]);
  const [wards, setWards] = useState([]);
  const [locations, setLocations] = useState([]);
  const [id] = localStorage.getItem("id");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [message] = useState("");

  //localStorage.setItem("id", setFormData.data.id);

  const [formData, setFormData] = useState({
    name: "",
    mobileNo: "",
    email: "",
    address: "",
    grievanceTypeId: "",
    subTypeId: "",
    zoneId: "",
    wardId: "",
    locationId: "",
    description: "",
    user: ""
  });

  useEffect(() => {
    loadMasters();
  }, []);

  const loadMasters = async () => {
    try {
      //   const [typeRes, zoneRes] = await Promise.all([
      //     api.get("/Grievance/GetGrievanceType/"),
      //     api.get("/Grievances/GetZone"),
      //   ]);
      const [typeRes, zoneRes] = await Promise.all([
        api.get("/Grievance/GetGrievanceType"),
        api.get("/Grievance/GetZone"),
      ]);

      console.log("Type Data", typeRes.data);
      console.log("Zone Data", zoneRes.data);
      setGrievanceTypes(typeRes.data || []);
      setZones(zoneRes.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Zone -> Ward
    if (name === "zoneId") {
      setFormData((prev) => ({
        ...prev,
        zoneId: value,
        wardId: "",
        locationId: "",
      }));

      try {
        const res = await api.get(`/Grievance/GetZoneByWards/${value}`);

        setWards(res.data || []);
        setLocations([]);
      } catch {
        setWards([]);
        setLocations([]);
      }
    }

    // Ward -> Location
    if (name === "wardId") {
      setFormData((prev) => ({
        ...prev,
        wardId: value,
        locationId: "",
      }));

      try {
        const res = await api.get(`/Grievance/GetWardsByLocation/${value}`);

        setLocations(res.data || []);
      } catch {
        setLocations([]);
      }
    }

    // Type -> Sub Type
    if (name === "grievanceTypeId") {
      setFormData((prev) => ({
        ...prev,
        grievanceTypeId: value,
        subTypeId: "",
      }));

      try {
        const res = await api.get(
          `/Grievance/GetGrievanceByGrievanceSubType/${value}`,
        );

        setGrievanceSubTypes(res.data || []);
      } catch {
        setGrievanceSubTypes([]);
      }
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    setImage(file);

    if (file) {
      setImagePreview(URL.createObjectURL(file));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = [];

    if (!formData.name.trim()) errors.push("Name");
    if (!formData.mobileNo.trim()) errors.push("Mobile Number");

    if (formData.mobileNo && !/^[0-9]{10}$/.test(formData.mobileNo)) {
      errors.push("Valid 10 Digit Mobile Number");
    }

    if (
      formData.email &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      errors.push("Valid Email Address");
    }

    if (!formData.zoneId) errors.push("Zone");
    if (!formData.wardId) errors.push("Ward");
    if (!formData.locationId) errors.push("Location");
    if (!formData.grievanceTypeId) errors.push("Grievance Type");
    if (!formData.subTypeId) errors.push("Grievance Sub Type");
    if (!formData.address.trim()) errors.push("Address");
    if (!formData.description.trim()) errors.push("Description");
    // if (!formData.image) errors.push("Image");
    if (!captchaAnswer) errors.push("Captcha");

    if (captchaAnswer && parseInt(captchaAnswer) !== captcha1 + captcha2) {
      errors.push("Please Enter Valid Captcha");
    }

    if (errors.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Please Fill Required Fields",
        html: errors.map((x) => `• ${x}`).join("<br/>"),
      });
      return;
    }

    try {
      const data = new FormData();
      data.append("Name", formData.name);
      data.append("MobileNo", formData.mobileNo);
      data.append("Email", formData.email);
      data.append("ZoneId", formData.zoneId);
      data.append("WardId", formData.wardId);
      data.append("LocationId", formData.locationId);
      data.append("GrievanceTypeId", formData.grievanceTypeId);
      data.append("SubTypeId", formData.subTypeId);
      data.append("Address", formData.address);
      data.append("Description", formData.description);
      //data.append("Image", formData.image);
     data.append("User", id);

      data.append("CaptchaAnswer", captchaAnswer);
      data.append("CaptchaExpected", captcha1 + captcha2);

      if (image) {
        data.append("Image", image);
      }

      const res = await api.post("/Grievance/AddWithGID", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Success",
        text: `Complaint Registered Successfully : ${res.data.grievanceNo}`,
      });

      setFormData({
        name: "",
        mobileNo: "",
        email: "",
        address: "",
        grievanceTypeId: "",
        subTypeId: "",
        zoneId: "",
        wardId: "",
        locationId: "",
        description: "",
       id: localStorage.getItem("id") || "",
      });

      setImage(null);
      setImagePreview("");
      setCaptchaAnswer("");
      setWards([]);
      setLocations([]);
      setGrievanceSubTypes([]);
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.response?.data || "Error while submitting grievance.",
      });
    }
  };

  return (
    
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h4 className="mb-0">Add Grievance</h4>
        </div>

        <div className="card-body">
          {message && <div className="alert alert-info">{message}</div>}

          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-4 mb-3">
                <label>Zone</label>
                <select
                  name="zoneId"
                  className="form-select"
                  value={formData.zoneId}
                  onChange={handleChange}
                >
                  <option value="">Select Zone</option>

                  {zones.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.zoneName || item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4 mb-3">
                <label>Ward</label>
                <select
                  name="wardId"
                  className="form-select"
                  value={formData.wardId}
                  onChange={handleChange}
                >
                  <option value="">Select Ward</option>

                  {wards.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.wardName || item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4 mb-3">
                <label>Location</label>
                <select
                  name="locationId"
                  className="form-select"
                  value={formData.locationId}
                  onChange={handleChange}
                >
                  <option value="">Select Location</option>

                  {locations.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.locationName || item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4 mb-3">
                <label>Grievance Type</label>
                <select
                  name="grievanceTypeId"
                  className="form-select"
                  value={formData.grievanceTypeId}
                  onChange={handleChange}
                >
                  <option value="">Select Type</option>

                  {grievanceTypes.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.gritype || item.id}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-8 mb-3">
                <label>Sub Type</label>
                <select
                  name="subTypeId"
                  className="form-select"
                  value={formData.subTypeId}
                  onChange={handleChange}
                >
                  <option value="">Select Sub Type</option>

                  {grievanceSubTypes.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name || item.griSubType}
                    </option>
                  ))}
                </select>
              </div>

          <div className="col-md-4 mb-3">
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={formData.name}
                  onChange={handleChange}
                  // required
                />

                 {/* <input
  type="text"
  name="id"
  className="form-control"
  value={id}
  onChange={handleChange}
/> */}
              </div>

              <div className="col-md-4 mb-3">
                <label>Mobile No</label>
                <input
                  type="text"
                  name="mobileNo"
                  className="form-control"
                  maxLength="10"
                  value={formData.mobileNo}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");

                    setFormData({
                      ...formData,
                      mobileNo: value,
                    });
                  }}
                />
              </div>

              <div className="col-md-4 mb-3">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-12 mb-3">
                <label>Address</label>
                <textarea
                  name="address"
                  className="form-control"
                  rows="2"
                  value={formData.address}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-12 mb-3">
                <label>Description</label>
                <textarea
                  name="description"
                  className="form-control"
                  rows="4"
                  value={formData.description}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4 mb-3">
                <label>Image</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={handleImageChange}
                />
              </div>

              {imagePreview && (
                <div className="col-md-4 mb-3">
                  <img
                    src={imagePreview}
                    alt="Preview"
                    width="150"
                    className="img-thumbnail"
                  />
                </div>
              )}

              <div className="col-md-4 mb-3">
                
                <label>
                  Captcha: {captcha1} + {captcha2} = ?
                </label>

                <input
                  type="number"
                  className="form-control"
                  value={captchaAnswer}
                  onChange={(e) => setCaptchaAnswer(e.target.value)}
                />
              </div>

              <div className="col-md-12 mb-3 p-4 text-center">
                
                <button type="submit" className="btn btn-primary">
                  Submit Grievance kkk
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    
  );
};

export default AddGrievance;
